export const OWN_COMPANY = 'Собственная компания';
